<form
  [formGroup]="$any(form)"
  class="panel-flex"
  (validSubmit)="onSubmit($event)"
>
  <div class="panel-body form-section">
    <app-custom-fields-edit
      [objectType]="id.objectType"
      [form]="form"
    ></app-custom-fields-edit>
  </div>

  <div class="panel-footer d-flex justify-content-end">
    <button
      data-dd-action-name="custom-fields-edit-side-panel.cancel-button"
      type="button"
      class="btn btn-outline"
      (click)="onClose()"
    >
      Cancel
    </button>

    <button
      data-dd-action-name="custom-fields-edit-side-panel.save-button"
      type="submit"
      class="btn btn-primary ms-2"
      [disabled]="form.disabled || form.pristine"
    >
      <i-lucide name="save"></i-lucide>
      Save
    </button>
  </div>
</form>
